// extracted by mini-css-extract-plugin
export default {"wrapper":"App_wrapper__sdzFD","body":"App_body__CLsxA","menu":"App_menu__C6Ubc","help":"App_help__sYmdQ","mobile":"App_mobile__GbZhW"};